import { Stream } from "./Stream";
import { Client } from "./Client";

const connect = async (
  env: {
    host?: string;
    debug?: boolean;
    queryParameters?: any;
    transports?: string[];
  } = {}
) => {
  return await Client.connect(env);
};

const channel = (channel: string) => {
  return Client.listen(channel);
};

const disconnect = (): void => {
  Client.disconnect();
};

function generateId() {
  const length = 20;
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+=_)(*&^%$#@!|}]{[";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

const privateOnce = async (
  channel: string,
  message: any,
  host: string = ""
) => {
  host = host == "" ? window.location.origin : host;
  const data = {
    type: "private",
    body: {
      from: generateId(),
      channel: channel,
      message: message,
    },
  };

  return await fetch(`${host}/stream/api/private`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

const publicOnce = async (message: string, host: string = "") => {
  host = host == "" ? window.location.origin : host;
  const data = {
    type: "private",
    body: {
      from: generateId(),
      channel: "public",
      message: message,
    },
  };
  return await fetch(`${host}/stream/api/public`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

export {
  channel,
  connect,
  disconnect,
  privateOnce,
  publicOnce,
  Stream,
  generateId,
  Client,
};
